const buildTimestamp = (daysAgo = 0) => {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return date.toISOString();
};

const buildFutureDate = (daysAhead = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + daysAhead);
  return date.toISOString().split('T')[0];
};

// NOTE: Modeled comps have been temporarily removed.
// They may be re-added in the future when the model improves.
const DEFAULT_MODELED_COMPS = () => [];

const DEFAULT_GREENLIGHT_COMPS = () => [
  {
    id: 'sample_greenlight_1',
    compFilmId: 'tt3098765',
    compFilmTitle: 'Aurora Divide',
    assignedBy: 'Analyst Team',
    assignedAt: buildTimestamp(10),
    reason: 'Shares release corridor and four-quadrant positioning with similar campaign cadence.'
  },
  {
    id: 'sample_greenlight_2',
    compFilmId: 'tt3098766',
    compFilmTitle: 'Edge of Tomorrowland',
    assignedBy: 'Analyst Team',
    assignedAt: buildTimestamp(18),
    reason: 'Comparable franchise awareness lift and premium format strategy.'
  }
];

const buildMetadata = () => ({
  isSample: true,
  source: 'local-fallback',
  generatedAt: new Date().toISOString()
});

export const getSampleFilmComps = (filmId, filmTitle = 'Sample Film') => {
  const modeledComps = DEFAULT_MODELED_COMPS();
  const greenlightComps = DEFAULT_GREENLIGHT_COMPS();
  const totalCount = greenlightComps.length; // Only count greenlight comps
  const modeledCount = 0; // Not used
  const greenlightCount = greenlightComps.length;

  return {
    filmId,
    filmTitle,
    modeledComps, // Empty array - kept for API compatibility
    greenlightComps,
    totalCount,
    modeledCount,
    greenlightCount,
    metadata: buildMetadata()
  };
};

export const getSampleComparison = (filmId, filmTitle = 'Sample Film') => {
  const sampleComps = getSampleFilmComps(filmId, filmTitle);
  const releaseDate = buildFutureDate(45);

  const modeledComparisons = sampleComps.modeledComps.map((comp, index) => ({
    compId: comp.id,
    compFilmId: comp.compFilmId,
    compFilmTitle: comp.compFilmTitle,
    compType: 'modeled',
    confidenceScore: comp.confidenceScore,
    matchingCriteria: comp.matchingCriteria,
    comparisonMetrics: {
      daysDifference: (-1 * (index + 1)) * 7,
      weeksDifference: -(index + 1),
      runtimeDifference: (index - 1) * 180,
      releaseYearDifference: index - 1
    }
  }));

  const greenlightComparisons = sampleComps.greenlightComps.map((comp, index) => ({
    compId: comp.id,
    compFilmId: comp.compFilmId,
    compFilmTitle: comp.compFilmTitle,
    compType: 'greenlight',
    assignedBy: comp.assignedBy,
    assignedAt: comp.assignedAt,
    matchingCriteria: {
      studio: 0.78 - index * 0.05,
      audience: 0.81 - index * 0.04,
      marketing: 0.74 - index * 0.03
    },
    comparisonMetrics: {
      daysDifference: (index + 1) * 5,
      weeksDifference: (index + 1),
      runtimeDifference: (index + 1) * 90,
      releaseYearDifference: index + 1
    }
  }));

  return {
    primaryFilm: {
      filmId,
      title: filmTitle,
      releaseDate,
      runtime: 7200,
      productionStatus: 'In Post-Production',
      categories: ['Action', 'Thriller']
    },
    comps: [...modeledComparisons, ...greenlightComparisons],
    summary: {
      totalComps: sampleComps.totalCount,
      modeledComps: sampleComps.modeledCount,
      greenlightComps: sampleComps.greenlightCount,
      averageConfidenceScore: sampleComps.metadata.averageConfidenceScore
    },
    metadata: sampleComps.metadata
  };
};

export default {
  getSampleFilmComps,
  getSampleComparison
};
